//инициализация первого елемента   input=[file]  --        ___________________
$('body').on('ajaxResponse', function() {
	let yamLabelFile = document.querySelectorAll('.yamLabelFile');

	/*функция добавляет обработчик очистки input*/
	function resetFile(parent) {
		let input = parent.querySelector('[type=file]');
		if (input.value !== '') {
			//console.log(input);
			let span = document.createElement("span");
			span.classList.add('remove-form-file');
			span.innerHTML = '<svg width=\"24px\" height=\"24px\"><use xlink:href=\"#svg-remove-file\"></use></svg>';
			//console.log(input);
			span.addEventListener('click', function(e) {
				let blockOutputPhoto = this.parentNode.querySelector('.blockOutputPhoto');
				input.value = '';
				blockOutputPhoto.remove();
				this.remove();
			});
				parent.appendChild(span);
			//input.classList.add('delete-file-button');
		}
		else {
			let svg = parent.querySelector('.remove-form-file');
			if(svg){
				svg.remove();
			}
		}

	}

	for(let i = 0; i < yamLabelFile.length; i++) {
		yamLabelFile[i].childNodes.forEach(function(element) {
			element.type === 'file' ?  element.addEventListener('change', function() {
				//получаем родительский блок
				let parent = element.closest('.blockFile');
				//проверяем наличие уже существующего блока если есть удалить
				if(parent.querySelector('.blockOutputPhoto')){
					parent.querySelector('.blockOutputPhoto').remove();
				}
				//если есть svg удалить
				if(parent.querySelector('.remove-form-file')) {
					parent.querySelector('.remove-form-file').remove();
				}
				//очищаем поле file вешаем событие на удаление и добавляем svg иконку
				resetFile(parent);

				//создаем блок ребенка и добавляем
				let createBlock = document.createElement('div');
				createBlock.classList.add('blockOutputPhoto');
				parent.appendChild(createBlock);
				//записываем имена файлов в блок
				for(var y = 0; y < this.files.length; y++) {
					let element = document.createElement('div');
					element.classList += 'outputFile_child';
					element.innerText += this.files[y].name;
					//console.log(this.files[y].name);
					parent.querySelector('.blockOutputPhoto').append(element);
					// getParent.querySelector('.blockOutputPhoto').innerHTML +=`<svg width="24px" height="24px"><use xlink:href="#svg-remove-file"></use></svg>`;
					// console.log(element.parentNode.parentNode);
				}
			}) :  false
		});
	};
});




// WEBPACK FOOTER //
// ./libs/inputTypeFile.js